import React from "react";
import "./Contact.css";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <div className="contact">
      <div className="con-main">
        <div className="conmap">
          <div class="mapouterc">
            <div class="gmap_canvasc">
              <iframe
                title="map"
                class="gmap_iframec"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=swajit engineering pvt ltd&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              ></iframe>
            </div>
          </div>
        </div>

        <div className="contact-content">
          <div className="cchead">
            <p className="contact-p">Head Office</p>

            <div className="ccadd">
              <p className="contact-p">Swajit Engineering Pvt. Ltd.</p>
              <p>
                <address>
                  K-9, M.I.D.C., Opp. Goodyear Tyre,
                  <br />
                  Waluj, Aurangabad-431136
                  <br />
                  Maharashtra,India
                  <br />
                </address>
              </p>
            </div>

            <div className="ccdetail">
              <p className="contact-p">Contact Details</p>
              <div className="contact-li">
                <li>+91-240-2555031/ +91-240-2554531</li>
                <li>+91 9922941689</li>
                <li>+91-240-2555032</li>
                <li>sandesh.borade</li>
                <li>marketing@swajit.com</li>
                <Link to="/home">
                  <li>www.swajit.com</li>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contactform">Contact Us</div>
      <div className="Form">
        <div className="feedformc">
          <form>
            <div className="formlabel">
              <label className="inputlabel" for="fname">
                Your name(required)
              </label>
              <br />
              <input className="finput" type="text" id="name" name="name" />
            </div>

            <div className="formlabel">
              <label className="inputlabel" for="fname">
                Your Email(required)
              </label>
              <br />
              <input className="finput" type="text" id="email" name="email" />
            </div>

            <div className="formlabel">
              <label className="inputlabel" for="fname">
                Phone number
              </label>
              <br />
              <input
                className="finput"
                type="text"
                id="subject"
                name="subject"
              />
            </div>

            <div className="formlabel">
              <label className="inputlabel" for="fname">
                Your Message
              </label>
              <br />
              <textarea className="tinput" id="area" rows={15} />
            </div>
            <input className="btn" type="submit" value={"Send"} />
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
